import { useState } from "react";
import { toast } from "sonner";
import { CheckCircle2, XCircle, HelpCircle } from "lucide-react";
import { api, errMsg } from "../lib/api";

export const PartCheck = ({ slug, modId, part, isLast, onContinue }) => {
  const [pick, setPick] = useState(-1);
  const [res, setRes] = useState(null);
  const submit = async () => {
    try {
      const { data } = await api.post(`/learn/${slug}/modules/${modId}/parts/${part.id}/check`, { answer: pick });
      setRes(data);
    } catch (e) { toast.error(errMsg(e)); }
  };
  const optCls = (j) => {
    if (res) return j === res.answer ? "border-emerald-500 bg-emerald-50 font-semibold" : j === pick ? "border-rose-400 bg-rose-50" : "opacity-60";
    return pick === j ? "border-[#D4AF37] bg-[#D4AF37]/15 font-semibold" : "hover:bg-[#FAF8FC]";
  };
  return (
    <div className="fixed sm:absolute inset-0 z-50 sm:z-10 flex items-center justify-center bg-[#2A1233]/85 backdrop-blur-sm p-4 sm:p-6 sm:rounded-md animate-in fade-in" data-testid="part-check-overlay">
      <div className="w-full max-w-lg bg-white rounded-lg p-4 sm:p-6 max-h-full overflow-y-auto shadow-2xl">
        <div className="flex items-center gap-2 dx-eyebrow"><HelpCircle className="w-4 h-4" />Quick check · {part.title}</div>
        <div className="font-semibold mt-2 text-sm sm:text-base" data-testid="part-check-question">{part.check.q}</div>
        <div className="mt-3 grid gap-2">
          {part.check.options.map((o, j) => (
            <button key={j} disabled={!!res} onClick={() => setPick(j)} data-testid={`part-check-opt-${j}`}
              className={`text-left rounded-md border px-3 py-2 text-xs sm:text-sm transition-colors ${optCls(j)}`}>{o}</button>
          ))}
        </div>
        {res && (
          <div className={`mt-3 rounded-md p-3 text-sm flex gap-2 ${res.correct ? "bg-emerald-50 text-emerald-800" : "bg-rose-50 text-rose-800"}`} data-testid="part-check-feedback">
            {res.correct ? <CheckCircle2 className="w-4 h-4 shrink-0 mt-0.5" /> : <XCircle className="w-4 h-4 shrink-0 mt-0.5" />}
            <span><b>{res.correct ? "Correct!" : "Not quite."}</b> {res.explain}</span>
          </div>
        )}
        {res
          ? <button className="dx-btn-purple mt-4" onClick={onContinue} data-testid="part-check-continue-btn">{isLast ? "Done" : "Continue to next part"}</button>
          : <button className="dx-btn-gold mt-4" disabled={pick < 0} onClick={submit} data-testid="part-check-submit-btn">Check answer</button>}
      </div>
    </div>
  );
};
